/**
 * @typedef {import('./lib/index.js').Options} Options
 * @typedef {import('./lib/index.js').Space} Space
 */

export {fromParse5} from './lib/index.js'
